<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>

      <div class="card">
        <div class="controls" v-if="reminder && reminder.id">
          <img
            @click="handleDelete"
            class="action clickable"
            style="width: 30px; float: right; cursor: pointer"
            src="@/assets/img/delete.svg"
          />
        </div>
        <h3>Reminder</h3>
        <form @submit.prevent="save" class="inputs" v-if="reminder">
          <div class="card">
            <p class="title">Survey Delivery Time</p>
            <div class="inputs">
              <div class="dates">
                <label>
                  Hour<span class="required">*</span>:
                  <input
                    type="number"
                    required
                    v-model.number="reminder.time.hour"
                    min="0"
                    max="23"
                  />
                  Minute<span class="required">*</span>:
                  <input
                    type="number"
                    required
                    v-model.number="reminder.time.minute"
                    min="0"
                    max="59"
                  />
                </label>
                <div class="input full select-checkbox">
                  <label>
                    Days
                    <span class="required">*</span>
                  </label>
                  <v-select
                    v-model="reminder.time.days"
                    :options="daysOfWeek"
                    label="text"
                    :reduce="(d) => d.day"
                    multiple
                  ></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="input full select-checkbox">
            <label>
              Form
              <span class="required">*</span>
            </label>
            <v-select
              v-model="reminder.form_id"
              :options="forms"
              label="title"
              :reduce="(d) => d.id"
            ></v-select>
          </div>
          <div class="input full select-checkbox">
            <label>
              Departments (Leave blank to include all current + future
              Departments)
            </label>
            <v-select
              v-model="reminder.departments"
              :options="Object.values(departments)"
              class="multiple"
              label="name"
              required
              :reduce="(d) => d.id"
              multiple
            ></v-select>
          </div>
          <div class="input full select-checkbox">
            <label>
              Locations (Leave blank to include all current + future Locations)
            </label>
            <v-select
              v-model="reminder.locations"
              :options="Object.values(locations)"
              class="multiple"
              label="name"
              required
              :reduce="(d) => d.id"
              multiple
            ></v-select>
          </div>
          <div hidden>
            <h3>
              Exceptions ( These selections will not be included when the
              messages go out )
            </h3>
            <hr />
            <div class="input full select-checkbox">
              <label> Locations </label>
              <v-select
                v-model="reminder.exceptions.locations"
                :options="Object.values(locations)"
                class="multiple"
                label="name"
                required
                :reduce="(d) => d.id"
                multiple
              ></v-select>
            </div>
            <div class="input full select-checkbox">
              <label> Departments </label>
              <v-select
                v-model="reminder.exceptions.departments"
                :options="Object.values(departments)"
                class="multiple"
                label="name"
                required
                :reduce="(d) => d.id"
                multiple
              ></v-select>
            </div>
            <div class="input full select-checkbox">
              <label> Employees </label>
              <v-select
                v-model="reminder.exceptions.employees"
                :options="employees"
                :filterable="false"
                @search="onSearch"
                class="multiple"
                label="email"
                :reduce="(d) => d.id"
                multiple
              >
                <template
                  #option="{
                    email: email,
                    phone: phone,
                    first_name: first_name,
                    last_name: last_name,
                    employee_number: employee_number,
                  }"
                >
                  <h3 style="margin: 0">
                    <span v-html="first_name"></span> &nbsp;<span
                      v-html="last_name"
                    ></span>
                  </h3>
                  <div v-if="employee_number" v-html="employee_number"></div>
                  <div v-if="email" v-html="email"></div>
                  <div v-if="phone" v-html="phone"></div>
                </template>
                <template #list-footer>
                  <li style="text-align: center">Bottom of the list!</li>
                </template>
              </v-select>
            </div>
          </div>

          <br />
          <div class="btns left">
            <button class="btn round-btn">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
import DashboardPages from "@/utilities/menu.js";
import Switches from "vue-switches";
import Moment from "moment-timezone";
import { db, auth, functions } from "../firebaseConfig.js";

export default {
  components: {
    Switches,
  },
  data() {
    return {
      reduce_function(d, index, arr) {
        return d.name;
      },
      employee_choices: {},
      reminder: {
        form_id: "",
        locations: [],
        departments: [],
        time: {
          days: [],
          minute: 0,
          hour: 0,
          timezone: "America/New_York",
        },
        exceptions: {
          locations: [],
          departments: [],
          employees: [],
        },
        status: false,
        created_at: Date.now(),
      },
      notifications: false,
      password: null,
      daysOfWeek: [],
      forms: [],
      locations: [],
      departments: [],
    };
  },
  computed: {
    employees() {
      return Object.values(this.employee_choices);
    },
    dashboardPages() {
      return DashboardPages;
    },
  },
  firestore() {
    return {
      forms: db.collection(`user/${this.$store.state.user_doc.id}/forms`),
      locations: db.collection(`user/${this.$store.state.user_doc.id}/locations`),
      departments: db.collection(`user/${this.$store.state.user_doc.id}/departments`),
    };
  },
  created() {
    let i = 0;
    while (i < 7) {
      this.daysOfWeek.push({
        day: i,
        text: Moment(`${i}`, "d").format("dddd"),
      });
      i++;
    }

    this.$bind(
      "reminder",
      db.doc(`user/${this.user_doc.id}/reminders/${this.$route.params.id}`)
    ).then((reminder) => {
      if (!reminder) {
        this.reminder = {
          form_id: "",
          locations: [],
          departments: [],
          time: {
            days: [],
            minute: 0,
            hour: 0,
            timezone: "America/New_York",
          },
          exceptions: {
            locations: [],
            departments: [],
            employees: [],
          },
          status: true,
          created_at: Date.now(),
        };
      }
    });
  },
  watch: {
    reminder: {
      handler(newVers, oldVers) {
        if (newVers.time.minute > 59 || newVers.time.minute < 0) {
          this.reminder.time.minute = oldVers.time.minute;
        }
        if (newVers.time.hour > 23 || newVers.time.hour < 0) {
          this.reminder.time.hour = oldVers.time.hour;
        }
      },
      deep: true,
    },
  },
  methods: {
    onSearch(search, loading) {
      const searchForEmployee = functions.httpsCallable(
        "algolia-searchForEmployee"
      );
      loading(true);
      return searchForEmployee({
        user_id: this.user_doc.id,
        query: search,
      }).then((res) => {
        res.data
          .map((e) => {
            return {
              id: e.id,
              email: e._highlightResult.email
                ? e._highlightResult.email.value
                : e.email,
              phone: e._highlightResult.phone
                ? e._highlightResult.phone.value
                : e.phone,
              first_name: e._highlightResult.first_name
                ? e._highlightResult.first_name.value
                : e.first_name,
              last_name: e._highlightResult.last_name
                ? e._highlightResult.last_name.value
                : e.last_name,
              employee_number: e._highlightResult.employee_number
                ? e._highlightResult.employee_number.value
                : e.employee_number,
            };
          })
          .forEach((e) => {
            this.employee_choices[e.id] = e;
            this.employee_choices = Object.assign({}, this.employee_choices);
          });
        loading(false);
      });
    },
    save() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      return Promise.resolve()
        .then(async () =>
          this.$firestoreRefs.reminder.set(this.reminder, { merge: true })
        )
        .then((reminder) => {
          loader.hide();
          return Swal.fire("Reminder has been Saved", "", "success");
        })
        .then(() => {
          return this.goTo("/reminderManagement");
        })
        .catch((err) => {
          loader.hide();
          Swal.fire("Error", err.message, "error");
        });
    },
    handleDelete() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("reminders")
            .doc(this.$route.params.id)
            .delete()
            .then(() => {
              return Swal.fire(
                "Deleted!",
                "The page has been deleted.",
                "success"
              ).then(() => {
                this.goTo("/reminderManagement");
              });
            });
        }
      });
    },
  },
};
</script>

<style>
.select-checkbox.input > div {
  position: relative;
}
.select-checkbox.input > div label {
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: -22px;
  color: grey;
  font-weight: normal;
}

.select-checkbox.input > div label input {
  width: auto !important;
  margin: 0 !important;
  margin-right: 5px !important;
}
</style>
